// import axios from 'axios';
// const deploymentServer = 'http://mms.saudigrp.com/api';
// export const baseURL = deploymentServer; //for production
// export default baseURL;
// const myUrl = window.location.origin
// export const reactURL = myUrl;
// export const SHJC_URL = myUrl;
// export const REACT_URL = 'http://localhost:3000/';

// export const getAsync = async (url, requestHeaders, contentType = 'application/json') => {
//   let headers = mergeHeaders(requestHeaders, contentType);
//   const response = await axios.get(`${baseURL}/${url}`, { headers });
//   return response?.data;
// };

// export const postAsync = async (
//   url,
//   requestBody,
//   requestHeaders,
//   contentType = 'application/json'
// ) => {
//   let headers = mergeHeaders(requestHeaders, contentType);
//   const response = await axios.post(`${baseURL}/${url}`, requestBody, { headers });
//   return response?.data;
// };

// export const putAsync = async (
//   url,
//   requestBody,
//   requestHeaders,
//   contentType = 'application/json'
// ) => {
//   let headers = mergeHeaders(requestHeaders, contentType);
//   const response = await axios.put(`${baseURL}/${url}`, requestBody, { headers });
//   return response?.data;
// };

// // export const deleteAsync = async (url, requestBody, contentType = 'application/json', requestHeaders = null) => {
// //     let headers = mergeHeaders(requestHeaders, contentType);
// //     const data = requestBody;
// //     const response = await axios.delete(`${baseURL}/${url}`,{
// //         headers,
// //         data,
// //     });
// //     return response?.data;
// // }

// export const deleteAsync = async (url, requestHeaders, contentType = 'application/json') => {
//   let headers = mergeHeaders(requestHeaders, contentType);
//   // const data = requestBody;
//   const response = await axios.delete(`${baseURL}/${url}`, {
//     headers
//   });
//   return response?.data;
// };

// export const loginAsync = async (
//   url,
//   requestBody,
//   requestHeaders,
//   contentType = 'application/json'
// ) => {
//   let headers = mergeHeaders(requestHeaders, contentType);
//   const response = await axios.post(`${baseURL}/${url}`, requestBody, { headers });
//   return response?.data;
// };

// function mergeHeaders(requestHeaders, contentType) {
//   const token = localStorage.getItem('token');
//   let headers = {};
//   const authorizationHeader = {
//     Authorization: `Bearer ${token}`
//   };
//   const contentTypeHeader = {
//     'Content-Type': contentType
//   };
//   headers = {
//     ...authorizationHeader,
//     ...contentTypeHeader
//   };
//   return { ...requestHeaders, ...headers };
// }

// src/services/httpService.js

import axios from 'axios';

const deploymentServer = 'http://mms.saudigrp.com/api';
export const baseURL = deploymentServer;
export const reactURL = window.location.origin;
export const SHJC_URL = window.location.origin;
export default baseURL;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      const isAdmin = JSON.parse(localStorage.getItem('isAdmin'));
      localStorage.clear();

      window.location.href = isAdmin ? '/managementLogin' : '/donorLogin';
    }
    return Promise.reject(error);
  },
);

export const getAsync = async (url, requestHeaders = {}) => {
  const response = await axiosInstance.get(url, { headers: requestHeaders });
  return response.data;
};

// export const postAsync = async (url, requestBody, requestHeaders = {}) => {
//   const response = await axiosInstance.post(url, requestBody, { headers: requestHeaders });
//   return response.data;
// };
export const postAsync = async (url, requestBody, requestHeaders = {}, contentType) => {
  const response = await axiosInstance.post(url, requestBody, {
    headers: { ...requestHeaders, 'Content-Type': contentType },
  });
  return response.data;
};

export const putAsync = async (url, requestBody, requestHeaders = {}, contentType) => {
  const response = await axiosInstance.put(url, requestBody, {
    headers: { ...requestHeaders, 'Content-Type': contentType },
  });
  return response.data;
};

export const deleteAsync = async (url, requestHeaders = {}) => {
  const response = await axiosInstance.delete(url, { headers: requestHeaders });
  return response.data;
};

export const loginAsync = async (url, requestBody, requestHeaders = {}) => {
  // no token in login request, so bypass axiosInstance
  const response = await axios.post(`${baseURL}/${url}`, requestBody, {
    headers: {
      'Content-Type': 'application/json',
      ...requestHeaders,
    },
  });
  return response.data;
};
